import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { WordpressService } from '../wordpress.service';
import { PlayerService } from '../player.service';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router} from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-list-horizont',
  templateUrl: './list-horizont.component.html',
  styleUrls: ['./list-horizont.component.scss']
})
export class ListHorizontComponent implements OnInit {

  @ViewChild('slideContainer', { static: true }) slideContainer: ElementRef;
  haveRight:boolean = true
  haveLeft:boolean = false
  posts$: Observable<any[]>;
  pages$: Observable<any[]>;
  categories$:Observable<any[]>;
  state$: Observable<object>;
  single:boolean = false;
  showPages:boolean = false;
  icy_metadata;

  constructor(
    private wp : WordpressService,
    public playerService:PlayerService,
    private route: ActivatedRoute,
    private sanitize: DomSanitizer,
    private router:Router,
  ) {
    /* actualizar la información del stream */
    playerService.icy_metadata$
    .subscribe( (res:string) => {

      let item:HTMLElement = document.querySelector("div[title='"+res+"']")

      if (item==null) return;

      if (this.icy_metadata!=res) {
        let items = document.querySelectorAll(".item")
        items.forEach(
          (item) => item.classList.remove('playing')
        )
        this.icy_metadata = res;
        item.classList.add('playing');
        this.setCurrentPodcast()
      }

    } )

  }

  setCurrentPodcast() {
    //console.log('set current podcast')
    this.posts$.subscribe(
      (posts) => {
        let post = posts.filter( (p) => p.acf.icy_metadata_identifier===this.icy_metadata );
        if (post && post[0] && post[0].slug && document.querySelector('#'+post[0].slug)) {
          //document.querySelector('#'+post[0].slug).scrollIntoView(true);
          // let a = document.getElementById(post[0].slug)
          // a.parentNode.scrollLeft = a.offsetLeft
          this.playerService.podcast(post)
        }
      }
    )
  }

  ngOnInit() {
    this.wp.getBrbaConfig()
    .subscribe(
      (data) => {
        if (data['color']) document.querySelector("body").style.cssText = "background-color: "+data['color'];
      }
    )

    //single or list
    this.route.params
    .subscribe(res => {
      this.single=false;
      this.showPages=false;
      if (res['slug']) {
        this.posts$ = this.wp.getPost(res['slug'])
        this.single=true;
      } else if (res['pageslug']) {
        this.posts$ = this.wp.getPosts();
        this.pages$ = this.wp.getPage(res['pageslug'])
        this.single=true;
        this.showPages=true;
      } else if (res['artxibo']) {
        if (history.state.categoryId) {
          this.posts$ = this.wp.getPostArtxibo(history.state.categoryId);
        } else {
          this.router.navigateByUrl('/');
        }
        this.pages$ = this.wp.getPages();
        this.categories$ = this.wp.getCategories('artxibo');
      } else {
        this.wp.getBrbaConfig()
          .subscribe(
            (data) => {
              if (data['sticky']) this.posts$ = this.wp.getPostArtxibo(data['sticky']);
            }
          )
        this.pages$ = this.wp.getPages();
        this.categories$ = this.wp.getCategories('artxibo');
      }


    })


    this.icy_metadata = this.playerService.last_icy_metadata;

    //if (this.icy_metadata) this.setCurrentPodcast();
    this.haveLeft = (this.slideContainer && this.slideContainer.nativeElement.scrollLeft>0)

  }

  /*** Playing identifier **/
  // document.querySelector("#hello-world").scrollIntoView(true);
  // playing(icy:string) {
  //   return this.playerService.getIcyMetadata()===icy;
  // }

  /*** scrolling ***/
  moveLeft() {
    if (!this.slideContainer) return
    let scroll = this.slideContainer.nativeElement.scrollLeft
    let width = this.slideContainer.nativeElement.offsetWidth
    this.slideContainer.nativeElement.scroll(scroll-width,0)
    this.haveRight = true;
    this.haveLeft = ((scroll-width) > 0)
  }

  moveRight() {
    if (!this.slideContainer) return
    let scroll = this.slideContainer.nativeElement.scrollLeft
    let width = this.slideContainer.nativeElement.offsetWidth
    this.slideContainer.nativeElement.scroll(scroll+width,0)
    this.haveLeft = true;
    this.haveRight = ( (scroll+width*2) < this.slideContainer.nativeElement.scrollWidth )
  }

  /* Player **/
  playFile(post) {
    this.playerService.play(post.acf['archivo_de_sonido']['url']);
    this.playerService.podcast([post])
  }

}
